
import { Vue } from "vue-class-component";

class LeaderboardAreaIcon extends Vue {}
export default LeaderboardAreaIcon;
